export default __webpack_public_path__ + "static/media/feels.679da174.mp3";